<div class="video-recorder-container">
  <video #videoPreview class="video-preview" autoplay muted></video>

  <div class="controls-container">
    <div class="button-group">
      <button class="record-button" [disabled]="isRecording" (click)="toggleRecording()">
        Record
      </button>

      <button class="stop-button" [disabled]="!isRecording" (click)="stopRecording()">
        Stop
      </button>

      <button class="switch-camera-button" (click)="switchCamera()">
        Switch Camera
      </button>
    </div>

    <div class="timer-display" [ngClass]="{'timer-warning': remainingTime <= 5}">
      {{ formatRemainingTime() }}
    </div>
  </div>

</div>